module.exports = {
          srcSet: __webpack_public_path__ + "e1ae23b196b2d9ca440bd0f64492daa3-374.png"+" 374w",
          images:[ {path: __webpack_public_path__ + "e1ae23b196b2d9ca440bd0f64492daa3-374.png",width: 374,height: 240}],
          src: __webpack_public_path__ + "e1ae23b196b2d9ca440bd0f64492daa3-374.png",
          toString:function(){return __webpack_public_path__ + "e1ae23b196b2d9ca440bd0f64492daa3-374.png"},
          
          width: 374,
          height: 240
        }